import type { NavLink, SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

// Public storage address for images referenced directly from code.
// It follows the site's free subdomain: if the subdomain changes, update it here
// and in every image URL stored in the database.
export const CDN_BASE = 'https://guju-events.cdn.modulify.website'

export const siteConfig: SiteConfig = {
    name: 'Guju Events',
    tagline: 'Event Management Company',
    description: 'Guju Events is an Ahmedabad based event management company for luxury weddings, corporate events, garba nights, concerts, sports events and manpower across India.',
    url: getOrigin(),
    ogImage: `${CDN_BASE}/images/site/about-home.jpg`
}

export const contactInfo = {
    phoneDisplay: '+91 90339 79998',
    phoneHref: 'tel:+919033979998',
    whatsappNumber: '919033979998',
    email: 'gujuevents@gmail.com',
    addressShort: 'Nikol, Ahmedabad, Gujarat',
    addressFull: 'Nikol, Naroda, Ahmedabad 382345, Gujarat, India',
    mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Nikol%2C+Ahmedabad%2C+Gujarat+382345',
    instagram: 'https://www.instagram.com/gujuevents',
    facebook: 'https://www.facebook.com/gujuevents'
}

export const whatsappLink = (message?: string): string => {
    const base = `https://wa.me/${contactInfo.whatsappNumber}`
    return message ? `${base}?text=${encodeURIComponent(message)}` : base
}

export const navLinks: NavLink[] = [
    { href: '/', label: 'Home' },
    { href: '/about', label: 'About' },
    { href: '/services', label: 'Services' },
    { href: '/gallery', label: 'Gallery' },
    { href: '/clients', label: 'Clients' },
    { href: '/contact', label: 'Contact' }
]

export const eventRegions: string[] = ['Gujarat', 'Mumbai', 'Pune', 'Delhi', 'Bangalore', 'Rajasthan']

export const footerServiceLinks: NavLink[] = [
    { href: '/services#luxury-weddings', label: 'Luxury weddings' },
    { href: '/services#corporate-events', label: 'Corporate events' },
    { href: '/services#garba-navratri-nights', label: 'Garba and Navratri' },
    { href: '/services#live-concerts', label: 'Live concerts' },
    { href: '/services#sports-events', label: 'Sports and IPL manpower' },
    { href: '/services#manpower-services', label: 'Manpower services' }
]
